export default __webpack_public_path__ + "static/media/mountain_church_1280.316e19eb.webp";